import(/* webpackMode: "eager" */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/asbab-quest/page.tsx");
